import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CustomTabs, { tabsProps } from "../../../../../../components/Tabs";
import FullAndFinalSettings from "./FullAndFinalSettings";
import MiscellaneousSettings from "./MiscellaneousSettings";
import PaySlipSettings from "./PaySlipSettings";

const OtherSettings = () => {
    const locations = useLocation();
    const navigateto = useNavigate();
    const [activeTab] = React.useState<string>(locations.pathname);

    const Tabs: tabsProps[] = [
        { key: 'pay-slip-settings', label: 'Pay Slip Settings', content: <PaySlipSettings /> },
        { key: 'full-and-final-settings', label: 'Full & Final Settings', content: <FullAndFinalSettings /> },
        { key: 'miscellaneous-settings', label: 'Miscellaneous Settings', content: <MiscellaneousSettings /> },
    ]

    useEffect(() => {
        navigateto(`${activeTab}/${Tabs[0].key}`, { replace: true });
    }, []);

    const onTabChange = (activeKey: string) => {
        console.log(activeKey);
    }

    return <CustomTabs tabs={Tabs} routes={true} onTabChange={onTabChange} />
}

export default OtherSettings;